import { Flex, Panel } from "@coaching-culture/ui";
import { WidgetPanelHeader } from "pages/Dashboard/Widgets/WidgetPanelHeader";
import { MeasuresUpdater } from "pages/TeamView/MeasuresUpdater";

export type MeasuresWidgetProps = {
  relationshipId: string;
};

export const MeasuresWidget = ({ relationshipId }: MeasuresWidgetProps) => {
  return (
    <Panel width={"100%"} p={0}>
      <WidgetPanelHeader title="Update measures" />
      <Flex flexDirection={"column"} p={3} pt={4}>
        <MeasuresUpdater
          relationshipId={relationshipId}
          onUpdatedAll={() => {}}
        />
      </Flex>
    </Panel>
  );
};
